/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations, useScroll, Float, Edges } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import { mainStore } from '../../../store'

const material = new THREE.MeshStandardMaterial({
  color: '#ffffef',
  side: THREE.DoubleSide
})

const microscopeMaterial = new THREE.MeshStandardMaterial({
  color: '#ffffef'
})

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF(import.meta.env.BASE_URL + 'static/models/microscope.glb')
  const { actions } = useAnimations(animations, group)

  const scrollMap = mainStore.useStore(s => s.scrollMap)
  



  const data = useScroll()

  // useEffect(() => {
  //   actions.Anim_0.play()
  //   actions.Anim_0.timeScale= 0
  //   actions.Anim_0.clampWhenFinished = true
  // }, [])

  useEffect(() => void (actions['Anim_0'].play().paused = true), [actions])

  useFrame((state, delta) => {

    if(actions.Anim_0.time !== undefined) {

      actions.Anim_0.time = Math.min((0 + data.range((2.3/4) * scrollMap.one, 3/4 * scrollMap.one) * 3.4), 1.6820)

    }

    group.current.rotation.y += delta * 0.15

    // group.current.rotation.z = Math.max(((Math.PI * 0.55) - (data.range((2/4) * scrollMap.one, (3 / 4) * scrollMap.one) * 0.8 * Math.PI)), Math.PI * 0.08)
    group.current.position.z = Math.max((5 - data.range((2.2/4) * scrollMap.one, (3.7 / 4) * scrollMap.one) * 7), 0)

  }) 


  return (
    <group scale={0.1} position={[-1, -1, 0]} rotation-z={ Math.PI * 0.15} ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="microscope_eclats" position={[1.194, 11.234, -1.677]}>
          {/* <Float> */}

            <group name="eclats" position={[6.662, 5.681, -0.584]}>
              <mesh
                name="Polygone"
                geometry={nodes.Polygone.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone.morphTargetInfluences}
                position={[-2.017, -7.849, 1.45]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone001"
                geometry={nodes.Polygone001.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone001.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone001.morphTargetInfluences}
                position={[-0.507, 2.892, 1.014]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone002"
                geometry={nodes.Polygone002.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone002.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone002.morphTargetInfluences}
                position={[0.036, -2.846, 1.399]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone003"
                geometry={nodes.Polygone003.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone003.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone003.morphTargetInfluences}
                position={[-1.157, 2.167, 1.897]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone004"
                geometry={nodes.Polygone004.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone004.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone004.morphTargetInfluences}
                position={[0.9, -1.481, 2.369]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone005"
                geometry={nodes.Polygone005.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone005.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone005.morphTargetInfluences}
                position={[0.662, -1.524, -1.477]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone006"
                geometry={nodes.Polygone006.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone006.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone006.morphTargetInfluences}
                position={[-0.507, 2.892, 1.497]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone007"
                geometry={nodes.Polygone007.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone007.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone007.morphTargetInfluences}
                position={[1.601, 6.196, 1.091]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone008"
                geometry={nodes.Polygone008.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone008.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone008.morphTargetInfluences}
                position={[0.482, -0.708, -1.489]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone009"
                geometry={nodes.Polygone009.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone009.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone009.morphTargetInfluences}
                position={[-0.282, 3.841, 0.176]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone010"
                geometry={nodes.Polygone010.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone010.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone010.morphTargetInfluences}
                position={[0.376, 4.42, 0.447]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone011"
                geometry={nodes.Polygone011.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone011.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone011.morphTargetInfluences}
                position={[-0.121, 0.06, 2.357]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone012"
                geometry={nodes.Polygone012.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone012.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone012.morphTargetInfluences}
                position={[-1.612, -8.756, 0.662]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone013"
                geometry={nodes.Polygone013.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone013.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone013.morphTargetInfluences}
                position={[0.26, -0.227, -1.496]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone014"
                geometry={nodes.Polygone014.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone014.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone014.morphTargetInfluences}
                position={[0.376, 4.414, 0.641]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone015"
                geometry={nodes.Polygone015.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone015.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone015.morphTargetInfluences}
                position={[-0.785, 2.047, 0.114]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone016"
                geometry={nodes.Polygone016.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone016.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone016.morphTargetInfluences}
                position={[0.26, -0.148, -1.265]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone017"
                geometry={nodes.Polygone017.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone017.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone017.morphTargetInfluences}
                position={[-0.81, 1.698, 1.432]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone018"
                geometry={nodes.Polygone018.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone018.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone018.morphTargetInfluences}
                position={[-0.855, -5.246, -0.117]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone019"
                geometry={nodes.Polygone019.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone019.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone019.morphTargetInfluences}
                position={[-0.431, 0.186, -0.979]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone020"
                geometry={nodes.Polygone020.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone020.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone020.morphTargetInfluences}
                position={[-0.674, -7.018, 1.421]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone021"
                geometry={nodes.Polygone021.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone021.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone021.morphTargetInfluences}
                position={[0.366, -0.166, 2.357]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone022"
                geometry={nodes.Polygone022.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone022.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone022.morphTargetInfluences}
                position={[0.826, -0.843, -0.975]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone023"
                geometry={nodes.Polygone023.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone023.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone023.morphTargetInfluences}
                position={[0.166, 4.762, 1.356]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone024"
                geometry={nodes.Polygone024.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone024.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone024.morphTargetInfluences}
                position={[-0.756, 3.035, 1.511]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone025"
                geometry={nodes.Polygone025.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone025.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone025.morphTargetInfluences}
                position={[0.423, -1.271, 0.73]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone026"
                geometry={nodes.Polygone026.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone026.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone026.morphTargetInfluences}
                position={[0.587, -2.332, 0.726]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone027"
                geometry={nodes.Polygone027.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone027.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone027.morphTargetInfluences}
                position={[-0.649, 0.186, -0.979]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone028"
                geometry={nodes.Polygone028.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone028.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone028.morphTargetInfluences}
                position={[-1.395, 1.602, -0.256]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone029"
                geometry={nodes.Polygone029.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone029.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone029.morphTargetInfluences}
                position={[0.664, -1.357, -1.469]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone030"
                geometry={nodes.Polygone030.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone030.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone030.morphTargetInfluences}
                position={[-0.649, 2.214, 1.432]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone031"
                geometry={nodes.Polygone031.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone031.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone031.morphTargetInfluences}
                position={[-0.386, 2.792, 0.641]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone032"
                geometry={nodes.Polygone032.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone032.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone032.morphTargetInfluences}
                position={[0.53, -3.473, 0.663]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone033"
                geometry={nodes.Polygone033.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone033.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone033.morphTargetInfluences}
                position={[-0.323, 0.153, 0.013]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone034"
                geometry={nodes.Polygone034.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone034.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone034.morphTargetInfluences}
                position={[0.363, -0.876, 2.812]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone035"
                geometry={nodes.Polygone035.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone035.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone035.morphTargetInfluences}
                position={[0.408, -1.252, 0.699]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone036"
                geometry={nodes.Polygone036.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone036.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone036.morphTargetInfluences}
                position={[-1.894, -9.179, 0.662]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone037"
                geometry={nodes.Polygone037.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone037.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone037.morphTargetInfluences}
                position={[-0.872, 3.035, 1.83]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone038"
                geometry={nodes.Polygone038.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone038.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone038.morphTargetInfluences}
                position={[-0.417, -7.051, 0.657]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone039"
                geometry={nodes.Polygone039.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone039.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone039.morphTargetInfluences}
                position={[-0.106, 0.137, 0.726]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone040"
                geometry={nodes.Polygone040.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone040.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone040.morphTargetInfluences}
                position={[0.31, -2.597, -0.475]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone041"
                geometry={nodes.Polygone041.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone041.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone041.morphTargetInfluences}
                position={[-0.298, -6.673, 0.304]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone042"
                geometry={nodes.Polygone042.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone042.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone042.morphTargetInfluences}
                position={[0.832, 6.78, 1.501]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone043"
                geometry={nodes.Polygone043.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone043.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone043.morphTargetInfluences}
                position={[-0.736, 1.27, 0.46]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone044"
                geometry={nodes.Polygone044.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone044.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone044.morphTargetInfluences}
                position={[-0.773, 1.251, 1.113]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone045"
                geometry={nodes.Polygone045.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone045.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone045.morphTargetInfluences}
                position={[-0.468, -5.179, -0.095]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone046"
                geometry={nodes.Polygone046.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone046.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone046.morphTargetInfluences}
                position={[1.518, 6.283, 1.091]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone047"
                geometry={nodes.Polygone047.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone047.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone047.morphTargetInfluences}
                position={[0.887, -1.4, -0.977]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone048"
                geometry={nodes.Polygone048.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone048.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone048.morphTargetInfluences}
                position={[0.917, -1.397, 2.381]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone049"
                geometry={nodes.Polygone049.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone049.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone049.morphTargetInfluences}
                position={[-0.808, 1.28, 0.269]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone050"
                geometry={nodes.Polygone050.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone050.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone050.morphTargetInfluences}
                position={[-1.081, 1.085, 1.364]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone051"
                geometry={nodes.Polygone051.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone051.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone051.morphTargetInfluences}
                position={[-0.282, 0.58, 0.43]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone052"
                geometry={nodes.Polygone052.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone052.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone052.morphTargetInfluences}
                position={[0.489, -0.312, -0.757]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone053"
                geometry={nodes.Polygone053.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone053.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone053.morphTargetInfluences}
                position={[0.363, -0.176, 2.847]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone054"
                geometry={nodes.Polygone054.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone054.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone054.morphTargetInfluences}
                position={[-0.282, 4.034, 0.048]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone055"
                geometry={nodes.Polygone055.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone055.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone055.morphTargetInfluences}
                position={[-0.966, -7.154, -0.087]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone056"
                geometry={nodes.Polygone056.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone056.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone056.morphTargetInfluences}
                position={[-0.569, 1.951, 0.814]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone057"
                geometry={nodes.Polygone057.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone057.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone057.morphTargetInfluences}
                position={[-0.569, 2.937, 0.227]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone058"
                geometry={nodes.Polygone058.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone058.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone058.morphTargetInfluences}
                position={[0.118, -2.824, -0.907]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone059"
                geometry={nodes.Polygone059.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone059.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone059.morphTargetInfluences}
                position={[-0.229, 0.065, -0.506]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone060"
                geometry={nodes.Polygone060.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone060.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone060.morphTargetInfluences}
                position={[0.899, 5.365, 0.091]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone061"
                geometry={nodes.Polygone061.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone061.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone061.morphTargetInfluences}
                position={[0.155, -5.154, 0.631]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone062"
                geometry={nodes.Polygone062.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone062.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone062.morphTargetInfluences}
                position={[-0.352, 2.786, 0.893]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone063"
                geometry={nodes.Polygone063.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone063.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone063.morphTargetInfluences}
                position={[1.54, 6.211, 0.175]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone064"
                geometry={nodes.Polygone064.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone064.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone064.morphTargetInfluences}
                position={[0.815, -1.979, -0.977]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone065"
                geometry={nodes.Polygone065.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone065.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone065.morphTargetInfluences}
                position={[0.166, 4.692, 1.107]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone066"
                geometry={nodes.Polygone066.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone066.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone066.morphTargetInfluences}
                position={[1.208, 6.167, -0.093]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone067"
                geometry={nodes.Polygone067.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone067.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone067.morphTargetInfluences}
                position={[-0.106, 0.137, 1.145]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone068"
                geometry={nodes.Polygone068.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone068.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone068.morphTargetInfluences}
                position={[-0.649, 2.293, 1.497]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone069"
                geometry={nodes.Polygone069.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone069.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone069.morphTargetInfluences}
                position={[0.899, 5.278, 0.391]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone070"
                geometry={nodes.Polygone070.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone070.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone070.morphTargetInfluences}
                position={[-0.57, -3.092, -0.093]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone071"
                geometry={nodes.Polygone071.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone071.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone071.morphTargetInfluences}
                position={[-0.627, -7.154, -0.078]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone072"
                geometry={nodes.Polygone072.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone072.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone072.morphTargetInfluences}
                position={[1.208, 6.211, -0.093]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone073"
                geometry={nodes.Polygone073.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone073.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone073.morphTargetInfluences}
                position={[0.809, -0.798, 2.333]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone074"
                geometry={nodes.Polygone074.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone074.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone074.morphTargetInfluences}
                position={[-0.569, 2.937, 0.152]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone075"
                geometry={nodes.Polygone075.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone075.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone075.morphTargetInfluences}
                position={[0.887, -1.357, -0.997]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone076"
                geometry={nodes.Polygone076.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone076.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone076.morphTargetInfluences}
                position={[1.369, 6.413, 1.388]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone077"
                geometry={nodes.Polygone077.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone077.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone077.morphTargetInfluences}
                position={[0.654, -0.876, 2.8]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone078"
                geometry={nodes.Polygone078.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone078.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone078.morphTargetInfluences}
                position={[0.084, 0.067, -0.992]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone079"
                geometry={nodes.Polygone079.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone079.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone079.morphTargetInfluences}
                position={[0.545, -2.148, 0.726]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone080"
                geometry={nodes.Polygone080.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone080.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone080.morphTargetInfluences}
                position={[0.168, -0.479, 0.699]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone081"
                geometry={nodes.Polygone081.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone081.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone081.morphTargetInfluences}
                position={[0.157, 0.004, -0.762]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone082"
                geometry={nodes.Polygone082.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone082.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone082.morphTargetInfluences}
                position={[1.564, 6.068, 0.362]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone083"
                geometry={nodes.Polygone083.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone083.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone083.morphTargetInfluences}
                position={[-0.91, -6.46, 1.433]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone084"
                geometry={nodes.Polygone084.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone084.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone084.morphTargetInfluences}
                position={[-0.774, 1.309, 0.944]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone085"
                geometry={nodes.Polygone085.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone085.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone085.morphTargetInfluences}
                position={[-0.796, 1.676, 0.944]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone086"
                geometry={nodes.Polygone086.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone086.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone086.morphTargetInfluences}
                position={[1.601, 6.07, 0.891]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone087"
                geometry={nodes.Polygone087.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone087.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone087.morphTargetInfluences}
                position={[-0.569, 2.047, 0.152]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone088"
                geometry={nodes.Polygone088.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone088.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone088.morphTargetInfluences}
                position={[0.503, -3.473, 0.663]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone089"
                geometry={nodes.Polygone089.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone089.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone089.morphTargetInfluences}
                position={[0.519, -0.321, 2.339]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone090"
                geometry={nodes.Polygone090.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone090.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone090.morphTargetInfluences}
                position={[0.654, -1.401, 2.822]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone091"
                geometry={nodes.Polygone091.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone091.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone091.morphTargetInfluences}
                position={[0.826, -1.169, -0.469]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone092"
                geometry={nodes.Polygone092.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone092.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone092.morphTargetInfluences}
                position={[0.539, -2.485, -0.932]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone093"
                geometry={nodes.Polygone093.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone093.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone093.morphTargetInfluences}
                position={[0.118, -5.402, 0.304]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone094"
                geometry={nodes.Polygone094.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone094.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone094.morphTargetInfluences}
                position={[1.373, 5.904, 0.668]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone095"
                geometry={nodes.Polygone095.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone095.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone095.morphTargetInfluences}
                position={[0.148, -2.757, -0.932]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
              <mesh
                name="Polygone096"
                geometry={nodes.Polygone096.geometry}
                material={ material }
                morphTargetDictionary={nodes.Polygone096.morphTargetDictionary}
                morphTargetInfluences={nodes.Polygone096.morphTargetInfluences}
                position={[-0.4, 2.227, 0.893]}
              >
                    <Edges
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={false}
                            polygonOffsetFactor={10}
                        />
              </mesh>
            </group>
          {/* </Float> */}
          <mesh
            name="Microscope"
            geometry={nodes.Microscope.geometry}
            material={ microscopeMaterial }
            position={[0.839, -0.079, 0.08]}
          >
             <Edges
                            lineWidth={0.5}
                            threshold={0.5}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={true}
                            polygonOffsetFactor={-10}
                        />

          </mesh>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload(import.meta.env.BASE_URL + 'static/models/microscope.glb')
